module.exports = __webpack_public_path__ + "static/assets/030b41f0e639ec6c245fd26c852cff70.jpg";